import React from "react";
import ReactDOM from "react-dom";
import App from "../components/SchoolTickets/App";
import Aos from "../components/aos";

/**
 * School Tickets
 */

const PageSchoolTickets = ($) => {
	if ($("body").hasClass("page-template-school-tickets")) {
		Aos();
		const schoolTicketing = document.getElementById("js-school-tickets");

		let props = {
			...(schoolTicketing && schoolTicketing.dataset),
		};
		ReactDOM.render(<App {...props} />, schoolTicketing);
	}
};

export default PageSchoolTickets;
